/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_RewardsInputs */

const en_your_rewards = /** @type {(inputs: Your_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your
Rewards`)
};

const ar_your_rewards = /** @type {(inputs: Your_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const de_your_rewards = /** @type {(inputs: Your_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const es_your_rewards = /** @type {(inputs: Your_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const fr_your_rewards = /** @type {(inputs: Your_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const it_your_rewards = /** @type {(inputs: Your_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ja_your_rewards = /** @type {(inputs: Your_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ko_your_rewards = /** @type {(inputs: Your_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const pt_br_your_rewards = /** @type {(inputs: Your_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ru_your_rewards = /** @type {(inputs: Your_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const th_your_rewards = /** @type {(inputs: Your_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const tr_your_rewards = /** @type {(inputs: Your_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_cn_your_rewards = /** @type {(inputs: Your_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_tw_your_rewards = /** @type {(inputs: Your_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的獎勵`)
};

/**
* | output |
* | --- |
* | "Your Rewards" |
*
* @param {Your_RewardsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const your_rewards = /** @type {((inputs?: Your_RewardsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_RewardsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_rewards(inputs)
	if (locale === "ar") return ar_your_rewards(inputs)
	if (locale === "de") return de_your_rewards(inputs)
	if (locale === "es") return es_your_rewards(inputs)
	if (locale === "fr") return fr_your_rewards(inputs)
	if (locale === "it") return it_your_rewards(inputs)
	if (locale === "ja") return ja_your_rewards(inputs)
	if (locale === "ko") return ko_your_rewards(inputs)
	if (locale === "pt_br") return pt_br_your_rewards(inputs)
	if (locale === "ru") return ru_your_rewards(inputs)
	if (locale === "th") return th_your_rewards(inputs)
	if (locale === "tr") return tr_your_rewards(inputs)
	if (locale === "zh_cn") return zh_cn_your_rewards(inputs)
	return zh_tw_your_rewards(inputs)
});